<template>
    <div class="p-col-12">
        <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
        <div class="card p-shadow-app">
            <header class="jumbotron">
                <h3> Perfil - Configurações</h3>
            </header>
            <form
                id="ProfileForm"
                name="ProfileForm"
                class="p-col-12 p-md-12"
                @submit.prevent="save"
            >
                <h5>Agenda</h5>
                <hr />
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-mt-3 p-field p-col-12 p-md-4">
                        <div class="p-mb-1">
                            <b>Cor da Intervenção Confirmada</b>
                        </div>
                        <ColorPicker
                            v-model="userInfo.interventionConfirmedColor"
                            format="hex"
                            class="color-picker"
                        />
                    </div>
                </div>

                <h5>Assinatura</h5>
                <hr />
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-4">
                        <div class="p-mb-2">
                            <small>Assinatura será usada para o relatório do cliente.</small>
                        </div>
                        <Button
                            label="Adicionar/atualizar assinatura"
                            icon="pi pi-eye"
                            class="p-button-success"
                            @click.prevent="show = true"
                        />
                        <DialogProfileSignature
                            :show="show"
                            @close="() => show = false"
                            />
                    </div>
                </div>

                <h5>Integração LG (XLiFT)</h5>
                <hr />
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-4">
                        <div class="p-mb-2">
                            <small>Código Técnico (Service Engineer Code)</small>
                        </div>
                        <InputText
                            v-model="configurations.lg_service_engineer_code"
                            placeholder="Código Técnico LG"
                        />
                    </div>
                </div>

                <div class="p-mt-5 p-text-right">
                    <Button
                        label="Gravar"
                        icon="pi pi-save"
                        class="p-button-success"
                        type="submit"
                        :loading="loading"
                        :disabled="loading"
                    />
                    <Button
                        label="Cancelar"
                        icon="pi pi-times"
                        class="p-button-danger p-ml-1"
                        @click="cancel"
                        :disabled="loading"
                    />
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import UserService from "@/services/user.service";
import ColorPicker from "primevue/colorpicker";
import DialogProfileSignature from '../components/profile/DialogProfileSignature.vue'

export default {
    name: "ProfileConfiguration",
    components: {
        ColorPicker,
        DialogProfileSignature
    },
    data() {
        return {
            loading: false,
            show: false,
            userInfo: {
                interventionConfirmedColor: '#ffffff',
                signature: null,
            },
            configurations: {
                lg_service_engineer_code: null
            }
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    created() {
        if (this.currentUser) {
            this.getProfileInfo();
        } else {
            this.$router.push("/login");
        }
    },
    methods: {
        async getProfileInfo() {
            this.loading = true;
            try {
                const response = await UserService.getUserInfo(this.currentUser.id);

                Object.assign(this.userInfo, response);
                Object.assign(this.configurations, response.configurations);
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Não foi possível carregar os dados do perfil.',
                    life: 3000
                });
            } finally {
                this.loading = false;
            }
        },
        async save() {
            this.loading = true;
            try {
                this.userInfo.configurations = this.configurations;
                const updatedUserInfo = await UserService.updateProfileConfiguration(
                    this.userInfo
                );

                Object.assign(this.userInfo, updatedUserInfo);
                Object.assign(this.configurations, updatedUserInfo.configurations);

                this.$store.commit('auth/updateUserSuccess', updatedUserInfo);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: 'Configurações guardadas com sucesso!',
                    life: 3000
                });

            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Não foi possível guardar as configurações.',
                    life: 3000
                });
            } finally {
                this.loading = false;
            }
        },
        cancel() {
            this.getProfileInfo();
        },
    }
}
</script>